import Grouped from './Grouped'
import Single from './Single'

export default function BarPlot({ variant = 'single', ...rest }) {
  return variant === 'grouped' ? <Grouped {...rest} /> : <Single {...rest} />
}
